module.exports = __webpack_public_path__ + "static/media/default-profile-pic.80465071.png";